import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";

import Preloader from "./components/Pre";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import Footer from "./components/Footer";

import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Resume from "./components/Resume/ResumeNew";
import ShopifyPortfolio from "./components/ShopifyPortfolio/ShopifyPortfolio";

import BlogList from "./pages/Blog/BlogList";
import BlogPost from "./pages/Blog/BlogPost";
import Contact from "./pages/Contact/Contact";
import ServicesIndex from "./pages/Services/ServicesIndex";
import ShopifyDevelopment from "./pages/Services/ShopifyDevelopment";
import WebApps from "./pages/Services/WebApps";
import ApiBackend from "./pages/Services/ApiBackend";
import PerformanceSeo from "./pages/Services/PerformanceSeo";

import Login from "./pages/Admin/Login";
import AdminLayout from "./pages/Admin/AdminLayout";
import Dashboard from "./pages/Admin/Dashboard";
import Editor from "./pages/Admin/Editor";
import { ProjectsList, ProjectsEditor } from "./pages/Admin/ProjectsAdmin";
import { ShopifyList, ShopifyEditor } from "./pages/Admin/ShopifyAdmin";
import { StackList, StackEditor } from "./pages/Admin/StackAdmin";
import ResumeAdmin from "./pages/Admin/ResumeAdmin";

import { AuthProvider } from "./context/AuthContext";

import "./style.css";
import "./App.css";

const GA_ID = "G-SNZEPTHXQW";

function usePageView() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const path = location.pathname + location.search;
    window.gtag("config", GA_ID, {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
      anonymize_ip: true,
    });
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
}

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  usePageView();
  return (
    <>
      {!isAdmin && <Navbar />}
      <ScrollToTop />
      {children}
      {!isAdmin && <Footer />}
    </>
  );
}

export default function App() {
  const [load, setLoad] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoad(false), 1100);
    return () => clearTimeout(t);
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Preloader load={load} />
        <div className="App">
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/project" element={<Projects />} />
              <Route path="/projects" element={<Navigate to="/project" replace />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="/shopify-portfolio" element={<ShopifyPortfolio />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<ServicesIndex />} />
              <Route path="/services/shopify-development" element={<ShopifyDevelopment />} />
              <Route path="/services/web-apps" element={<WebApps />} />
              <Route path="/services/api-backend" element={<ApiBackend />} />
              <Route path="/services/performance-seo" element={<PerformanceSeo />} />

              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="new" element={<Editor />} />
                <Route path="edit/:id" element={<Editor />} />
                <Route path="projects" element={<ProjectsList />} />
                <Route path="projects/new" element={<ProjectsEditor />} />
                <Route path="projects/:id" element={<ProjectsEditor />} />
                <Route path="shopify" element={<ShopifyList />} />
                <Route path="shopify/new" element={<ShopifyEditor />} />
                <Route path="shopify/:id" element={<ShopifyEditor />} />
                <Route path="stack" element={<StackList />} />
                <Route path="stack/new" element={<StackEditor />} />
                <Route path="stack/:id" element={<StackEditor />} />
                <Route path="resume" element={<ResumeAdmin />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Chrome>
        </div>
      </Router>
    </AuthProvider>
  );
}
